/**
 * Frontend-Service: Premium-Support-Verfügbarkeit
 *
 * Wrapper um GET /support/availability. Liefert typisierte AvailabilityState
 * Objekte für den useSupportAvailability-Hook.
 *
 * Backend-Server cached die Antwort 60s; Frontend cached zusätzlich client-
 * seitig ~15s (Cache-Control-Header). Daher kein zusätzliches App-Caching
 * notwendig.
 */

import apiClient from '../api/apiClient';

// Spiegelt das Backend-Interface (siehe backend/src/services/support/availabilityService.ts)
export type AvailabilityStatus =
  | 'active_now'
  | 'online'
  | 'on_break'
  | 'offline_today'
  | 'closed_period'
  | 'globally_off';

export type AvailabilityIndicator = 'green' | 'orange' | 'gray';

export interface AvailabilityState {
  status: AvailabilityStatus;
  indicator: AvailabilityIndicator;
  label: string;
  detail: string | null;
  nextAvailableAt: string | null;
  responseTimeMinutes: number;
  computedAt: string;
}

interface AvailabilityResponse {
  success: boolean;
  data: AvailabilityState;
}

export async function fetchSupportAvailability(): Promise<AvailabilityState> {
  const response = await apiClient.get<AvailabilityResponse>('/support/availability');
  return response.data.data;
}
